import { Navigate, Route, Routes } from "react-router-dom";

import { isAuthenticated } from "../utils/auth";
import AccessGroups from "../pages/Settings/AccessGroups/AccessGroups";
import SeeEdit from "../pages/Settings/AccessGroups/SeeEdit";
import CreateAccess from "../pages/Settings/AccessGroups/CreateAccess";
import ParcelDescription from "../pages/Settings/ParcelDescription/ParcelDescription";
import CurrentAccount from "../pages/Settings/CurrentAccount/CurrentAccount";
import CreateRegistrationType from "../pages/Settings/CreateRegistrationType/CreateRegistrationType";
import GeneralAddressConfiguration from "../pages/Settings/GeneralAddressConfiguration/GeneralAddressConfiguration";
import Index from "../pages/Settings/Index/Index";
import IndexInfo from "../pages/Settings/Index/IndexInfo";
import FinancialRemittanceReturn from "../pages/Settings/FinancialRemittanceReturn/FinancialRemittanceReturn";
import { OrderBlockLand } from "../pages/Settings/OrderBlockLand/OrderBlockLand";
import EditNomenclature from "../pages/Settings/EditNomenclature/EditNomenclature";
import PaymentMethods from "../pages/Settings/PaymentMethods/PaymentMethods";
import IbJuridicoConfig from "../pages/Settings/IbJuridico/IbJuridicoConfig";
import EditTypesRegistration from "../pages/Settings/AccessGroups/EditTypesRegistration";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const SettingsRoute = () => (
  <PrivateRoute>
    <Routes>
      <Route path="/accessGroups" element={<AccessGroups />} />
      <Route path="/accessGroups/seeEdit" element={<SeeEdit />} />
      <Route path="/accessGroups/editTypesRegistration" element={<EditTypesRegistration />} />
      <Route path="/accessGroups/createAccess" element={<CreateAccess />} />
      <Route path="/createParcelDescription" element={<ParcelDescription />} />
      <Route path="/currentAccount" element={<CurrentAccount />} />
      <Route
        path="/createRegistrationType"
        element={<CreateRegistrationType />}
      />
      <Route
        path="/generalAddressConfiguration"
        element={<GeneralAddressConfiguration />}
      />
      <Route path="/index" element={<Index />} />
      <Route path="/index/indexInfo" element={<IndexInfo />} />
      <Route
        path="/financialRemittanceReturn"
        element={<FinancialRemittanceReturn />}
      />
      <Route path="/OrderBlockLand" element={<OrderBlockLand />} />
      <Route path="/editNomenclature" element={<EditNomenclature />} />
      <Route path="/paymentMethods" element={<PaymentMethods />} />
      <Route path="/ibjuridicoConfig" element={<IbJuridicoConfig />} />
    </Routes>
  </PrivateRoute>
);
